var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.6557,
    ry: 25.9526,
    transform: "matrix(1 0 0 -1 26.3442 26.0474)",
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.455 36.0368C43.455 36.8341 43.1394 37.5987 42.5777 38.1625C42.016 38.7263 41.2542 39.043 40.4598 39.043H13.5032C12.7089 39.043 11.947 38.7263 11.3853 38.1625C10.8236 37.5987 10.5081 36.8341 10.5081 36.0368V19.5029C10.5081 18.7057 10.8236 17.941 11.3853 17.3773C11.947 16.8135 12.7089 16.4968 13.5032 16.4968H19.4936L22.4888 11.9875H31.4743L34.4694 16.4968H40.4598C41.2542 16.4968 42.016 16.8135 42.5777 17.3773C43.1394 17.941 43.455 18.7057 43.455 19.5029V36.0368Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9811 33.0306C30.2894 33.0306 32.9714 30.3388 32.9714 27.0183C32.9714 23.6978 30.2894 21.006 26.9811 21.006C23.6727 21.006 20.9907 23.6978 20.9907 27.0183C20.9907 30.3388 23.6727 33.0306 26.9811 33.0306Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.837980b80308d9cd7467164d05b4b96f.svg";
export { ForwardRef as ReactComponent };